import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Icon,
  useBreakpointValue,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../../../../../../../i18n';
import useLanguageOptions from '../../../../../../common/src/hooks/useLanguageOptions';
import { patchConversationById } from '../../../../../../conversations/src/api/patchConversationById';
import { useFlowsSession } from '../../../../api/getFlowsSessionById';
import useFlowsLanguageOptions from '../../../../hooks/useFlowsLanguageOptions';
import { useFlowsRouteParams } from '../../../../hooks/useFlowsRouteParams';
import useSessionId from '../../../../hooks/useSessionId';
import useTempLanguage from '../../../../hooks/useTempLanguage';

const LanguageChangeMenu: React.FC = () => {
  const { t } = useTranslation();
  const { sessionId, flowId } = useFlowsRouteParams();
  const qSessionId = useSessionId();
  const { data: session } = useFlowsSession(sessionId || qSessionId);
  const sessionFlowId = session?.flow_id || flowId || '';
  const isMobile = useBreakpointValue({ base: true, laptop: false });

  const { setTempLanguage } = useTempLanguage();
  const { userLang } = useLocale();

  const languages = useLanguageOptions();
  const options = useFlowsLanguageOptions(sessionFlowId);

  const handleOnMenuItemClick = async (lang: string) => {
    setTempLanguage(lang);
    try {
      if (sessionId || qSessionId) {
        await patchConversationById(sessionId || qSessionId, {
          language: lang,
        });
      }
    } catch (err) {
      console.error('Something went wrong when changing conversation language');
    }
  };

  if (options.length === 0) return null;

  return (
    <Menu isLazy>
      <MenuButton
        as={Button}
        w={{ laptop: '100%' }}
        minH="10"
        bg="secondary.600"
        color="secondary.300"
        p="0"
        px={{ base: '2.5', laptop: '0' }}
        _hover={{ bg: 'secondary.500' }}
        flexShrink={0}
      >
        {isMobile
          ? userLang.toUpperCase()
          : `${t('LANGUAGE')}: ${
              languages.find(({ value }) => value === userLang)?.label || ''
            }`}
        <Icon name="GeneralActionsChevronDown" boxSize={5} />
      </MenuButton>
      <MenuList zIndex="2">
        {options.map(({ label, value }) => (
          <MenuItem key={value} onClick={() => handleOnMenuItemClick(value)}>
            {label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default LanguageChangeMenu;
